<astral-layout-group [columns]="5" [tabletColumns]="2" [mobileColumns]="1" alignItems="end">
  <astral-select [control]="form.controls['imdMeterId']" [itemsSource]="meterSelection"></astral-select>
  <astral-input
    label="CONSUMPTION.MEDIA_TYPE.TYPE"
    [value]="meterTypeCaption"
    [readonly]="true"
    [translateValue]="true"
  ></astral-input>
  @if (form.controls['imdMeterId'].value) {
    <astral-input label="CONSUMPTION.PRICELIST.PRICELIST" [value]="imdPriceListName" [readonly]="true"></astral-input>
    <astral-select
      [control]="form.controls['imdMeterModelId']"
      [itemsSource]="modelSelection"
    ></astral-select>
  }
  @if (allowNewMeter) {
    <div class="astral-form-adjacent-action">
      <astral-button
        variant="primary"
        size="small"
        icon="plus"
        labelKey="CONSUMPTION.METER.ADD"
        type="button"
        (click)="createMeter()"
      ></astral-button>
    </div>
  }
</astral-layout-group>

@if (showConsumption) {
  <div class="astral-stack-m">
    <app-period-consumption [meterId]="form.controls['imdMeterId'].value" [meterType]="meterType"></app-period-consumption>
  </div>
}
